import React from 'react';
import Head from 'next/head';
import { useSdkConfig } from '../utils/config';

export const LoadLegacyCss: React.FC = () => {
  const sdkConfig = useSdkConfig();

  return (
    <Head>
      <link rel="stylesheet" href={`/assets-react/legacy.css?${sdkConfig.version}`} />
    </Head>
  );
};
